import { takeEvery, takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { ResourceActionCreator, ResourceFailureActionCreator } from '../core/resourceStoreTypes';
import * as actions from './userInfoActions';
import { transformResponseToUserinfo } from './userInfoTransformers';
import type { UserInfoProps } from './userInfoTypes';

const mkQcsSyncUserInfoConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<UserInfoProps>();
const mkResourceConfig = (
  successAction: ResourceActionCreator<UserInfoProps>,
  failureAction: ResourceFailureActionCreator,
) =>
  mkQcsSyncUserInfoConfig({
    resourceName: 'userInfo',
    resourceBaseUrl: '/userinfo',

    axiosConfig: { headers: { 'qcs-dataset-id': null } },

    transformResponseToResource: transformResponseToUserinfo,

    successAction,
    failureAction,
  });

export function* getUserInfoActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getUserInfoSuccess, actions.getUserInfoFailure);
  yield takeLeading(actions.getUserInfo, resourceSagaUtils.qcsSyncGetResource<UserInfoProps>, resourceConfig);
}

export function* userRegisterMeForBetaActionWatcher() {
  const config = mkQcsSyncUserInfoConfig({
    resourceName: 'registerMeForBeta',
    resourceBaseUrl: '/users/register-me-for-beta',
    successAction: actions.userRegisterMeForBetaSuccess,
    failureAction: actions.userRegisterMeForBetaFailure,
  });
  yield takeEvery(actions.userRegisterMeForBeta.type, resourceSagaUtils.qcsSyncCreateResource<UserInfoProps>, config);
}

export function* userUnregisterMeForBetaActionWatcher() {
  const config = mkQcsSyncUserInfoConfig({
    resourceName: 'unregisterMeForBeta',
    resourceBaseUrl: '/users/unregister-me-for-beta',
    successAction: actions.userUnregisterMeForBetaSuccess,
    failureAction: actions.userUnregisterMeForBetaFailure,
  });
  yield takeEvery(actions.userUnregisterMeForBeta.type, resourceSagaUtils.qcsSyncCreateResource<UserInfoProps>, config);
}

export default [getUserInfoActionWatcher, userRegisterMeForBetaActionWatcher, userUnregisterMeForBetaActionWatcher];
